import ApplicationJSONAPISerializer from 'district-ui-client/serializers/application'

export default class ImportScheduleSerializer extends ApplicationJSONAPISerializer {}
